import { makeContractCancellationsRepository } from 'modules/customer/infra/repositories';

import { FetchContractCancellationCommunicationsUseCase } from './implementations/FetchContractCancellationCommunicationsUseCase';

let instance: FetchContractCancellationCommunicationsUseCase | null = null;

export default function makeFetchContractCancellationCommunicationsUseCase() {
  if (!instance) {
    const repository = makeContractCancellationsRepository();

    instance = new FetchContractCancellationCommunicationsUseCase(repository);
  }

  return instance;
}
